import * as Yup from "yup";

import {
  EXISTINGP,
  NEWP,
  Option,
  Options,
  PAYMENT_MODE,
} from "../../../../../../store/types";
import {
  convertDateToIndian,
  convertToInr,
  getSchemeDetails,
} from "../../../../../../utils/cart";
import { ChangeEvent, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  addItemsToCart,
  getSipSchemes,
  getSipFrequency,
  getMinimumAmount,
  getSipDayList,
  getAmcMasters,
  getSipCategory,
  getKycDetails,
  swpOptions,
} from "../../../../../../store/actions";
import { useAppSelector } from "../../../../../../store/hooks";
import {
  CalcSIPEnddt,
  checkAotmStatus,
  getFreedomSipCategories,
  getFreedomSipSchemes,
  getSipTenures,
  isSchemeFreedomEligible,
} from "../../../../../../store/actions/cart";
import {
  SipSchemeOptions,
  FrequencyOptions,
} from "../../../../../../store/types";
import { convertDate, handleError } from "../../../../../../utils/cart";
import { SIP_TYPE_OPTIONS_NEW } from "../../../../cart/CommercialTransactions";
import { getFrequencyName } from "../../../tranUtils";
import {
  getInvestorDetailsByPan,
  validateSubBroker,
} from "../../../../../../store/actions/cart";
import { FormikHelpers } from "formik";
import { mobileRegex } from "../..";
import { differenceInMonths } from "date-fns";
import moment from "moment";
import { TextFieldProps } from "@material-ui/core";
import { sipAutoRenewalEnddateCalculator } from "../../../../utils";

interface OnChange extends ChangeEvent<{ name?: string; value: any }> {}

type HandleChange = (
  values: Values,
  setValues: React.Dispatch<React.SetStateAction<Values>>
) => (event: OnChange) => any;

const FIELD_NAMES: Array<keyof Values> = [
  "fund",
  "sipType",
  "category",
  "email",
  "emailFamily",
  "mobile",
  "mobileFamily",
  "scheme",
  "modeOfRegistration",
  "frequency",
  "isFreedomEligible",
  "isFreedom",
  "sipTenure",
  "freedomCategory",
  "freedomScheme",
  "swpMinAmount",
  "noOfInstallments",
  "sipDay",
  "startDate",
  "endDate",
  "swpStartDate",
  "swpEndDate",
  "perpetual",
  "installmentAmount",
  "amount",
  "swpAmount",
];
const FAMILY_OPTIONS = [
  {
    label: "Self",
    value: "SE",
  },
  {
    label: "Spouse",
    value: "SP",
  },
  {
    label: "Dependent Children",
    value: "DC",
  },
  {
    label: "Dependent Siblings",
    value: "DS",
  },
  {
    label: "Dependent Parents",
    value: "DP",
  },
  {
    label: "Guardian",
    value: "GD",
  },
];
type HandleCheckBoxChange = (
  values: Values,
  setValues: React.Dispatch<React.SetStateAction<Values>>
) => (event: ChangeEvent<HTMLInputElement>, checked: boolean) => any;

export function useNewSip() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { arnCode, userId, investorData } = useAppSelector(
    ({ authReducer }) => ({
      arnCode: authReducer.token,
      userId: authReducer.userId,
      investorData: authReducer.investorData,
    })
  );

  const [amcMasters, setAmcMasters] = useState<Options>([]);
  const [modeOptions, setModeOptions] = useState<Options>([]);
  const [categories, setCategories] = useState<Options>([]);
  const [sipDays, setSipDays] = useState<Options>([]);
  const [euinOptions, setEuinOptions] = useState<Options>([]);
  const [freedomSchemes, setFreedomSchemes] = useState<SipSchemeOptions>([]);
  const [sipTenures, setSipTenures] = useState<
    Array<{ label: string; value: any; multiplier: number }>
  >([]);
  const [freedomCategories, setFreedomCategories] = useState<Options>([]);

  const [modalDetails, setModalDetails] = useState({
    isOpen: false,
    bulkOrderId: "",
    ihNo: "",
  });

  const [initialValues, setInitialValues] = useState<Values>({
    fund: "",
    endDate: "",
    frequency: "",
    installmentAmount: "",
    noOfInstallments: "",
    scheme: "",
    sipDay: "",
    sipType: "",
    startDate: "",
    amount: "",
    category: "",
    email: "",
    emailFamily: "",
    mobile: "",
    mobileFamily: "",
    arnCode: arnCode,
    euinDeclaration: "Yes",
    euin: "",
    perpetual: false,
    sipAutoRenewal: false,
    combo: false,
    invCategory: "11",
    modeOfRegistration: "",
    isFreedomEligible: false,
    isFreedom: "normalSip",
    freedomCategory: "",
    freedomScheme: "",
    sipTenure: "",
    swpStartDate: "",
    swpEndDate: "",
    swpAmount: "",
    swpMinAmount: "",
  });

  const [schemes, setSchemes] = useState<SipSchemeOptions>([]);
  const [frequencies, setFrequencies] = useState<FrequencyOptions>([]);

  function getFreedomArgs(values: Values) {
    if (values.isFreedom !== "freedomSip") {
      return {};
    }

    const { isSameScheme } = values;

    if (isSameScheme) {
      const selectedScheme = schemes.find((s) => s.value === values.scheme);

      const { scheme, plan, option, label } = selectedScheme;

      return {
        isFreedom: true,
        tenure: values.sipTenure,
        toScheme: scheme,
        toPlan: plan,
        toOption: option,
        withdrawalAmount: values.swpAmount,
        swpSchemeName: label,
        swpStartDate: convertDate(values.swpStartDate),
        swpEndDate: convertDate(values.swpEndDate),
      };
    }

    const selectedScheme = freedomSchemes.find(
      (s) => s.value === values.freedomScheme
    );
    const { scheme, plan, option, label } = selectedScheme;
    return {
      isFreedom: true,
      tenure: values.sipTenure,
      toScheme: scheme,
      toPlan: plan,
      toOption: option,
      withdrawalAmount: values.swpAmount,
      swpSchemeName: label,
      swpStartDate: convertDate(values.swpStartDate),
      swpEndDate: convertDate(values.swpEndDate),
    };
  }

  async function submit(
    values: Values,
    helpers: {
      setErrors: FormikHelpers<Values>["setErrors"];
      setFieldTouched: FormikHelpers<Values>["setFieldTouched"];
      validateForm: FormikHelpers<Values>["validateForm"];
    }
  ) {
    const errors = await helpers.validateForm(values);
    if (Object.keys(errors).length) {
      Object.keys(errors).forEach((error) => {
        helpers.setFieldTouched(error);
      });
      helpers.setErrors(errors);
      return;
    }
    try {
      const {
        fund,
        endDate,
        category,
        frequency,
        installmentAmount,
        amount,
        noOfInstallments,
        scheme,
        sipDay,
        startDate,
      } = values;
      const fundName = amcMasters.find(
        ({ value }) => value === values.fund
      ).label;

      const schemeDetails = schemes.find(({ value }) => value === scheme)!;

      const { option, plan, scheme: selectedScheme, label } = schemeDetails;

      const requestBody = {
        investorName: investorData.invname,
        pan: investorData.PAN,
        fund,
        scheme: selectedScheme,
        plan,
        option,
        arnCode,
        subArn: values.subArn,
        dcr: "KTRWD",
        euinDeclaration: values.euinDeclaration === "Yes" ? "N" : "Y",
        userId,
        euin: values.euinDeclaration === "Yes" ? values.euin : "",
        subBroker: values.subBrokerCode,
        amount: values.sipType === NEWP ? amount : 0,
        remarks: "0",
        sipFrequency: getFrequencyName(frequency),
        sipStartDate: convertDate(startDate),
        sipEndDate: convertDate(endDate),
        noOfInstallments: Number(noOfInstallments),
        schemeName: label,
        modeOfRegistration: values.modeOfRegistration,
        category,
        sipDay: sipDay,
        mobile: values.mobile.toString(),
        familyMobileFlag: values.mobileFamily,
        email: values.email,
        installmentAmount: Number(installmentAmount),
        familyEmailFlag: values.emailFamily,
        transactionType: values.sipType === NEWP ? "SIN" : "SINI",
        newPurchaseSipType: values.sipType === NEWP ? "SIPN" : "",
        combo: values.sipType === NEWP ? values.combo : false,
        fundName,
        invCategory: values.invCategory,
        perpetual: values.perpetual,
        sipAutoRenewal:values.sipAutoRenewal,
        sipAutoRenewalEnddate:sipAutoRenewalEnddateCalculator(values),
        ...getFreedomArgs(values),
      };

      history.replace("/new-investor-transaction/investor-details", {
        requestBody,
        isCart: false,
        isSingle: true,
        pan: requestBody.pan,
        transactionType: values.sipType === NEWP ? "SIN" : "SINI",
        newPurchaseSipType: values.sipType === NEWP ? "SIPN" : "",
        fund: requestBody.fund,
      });
    } catch (error) {
      handleError(error);
    }
  }

  async function addToCart(values: Values) {
    try {
      const {
        fund,
        endDate,
        category,
        frequency,
        installmentAmount,
        amount,
        noOfInstallments,
        scheme,
        sipDay,
        startDate,
      } = values;

      const schemeDetails = schemes.find(({ value }) => value === scheme)!;

      const { option, plan, scheme: selectedScheme, label } = schemeDetails;

      const fundName = amcMasters.find(
        ({ value }) => value === values.fund
      ).label;
      const requestBody = {
        fundName,
        investorName: investorData.invname,
        pan: investorData.PAN,
        fund,
        scheme: selectedScheme,
        plan,
        option,
        arnCode,
        subArn: values.subArn,
        dcr: "KTRWD",
        euinDeclaration: values.euinDeclaration === "Yes" ? "N" : "Y",
        userId,
        euin: values.euinDeclaration === "Yes" ? values.euin : "",
        subBroker: values.subBrokerCode,
        amount: values.sipType === NEWP ? amount : 0,
        remarks: "0",
        sipFrequency: getFrequencyName(frequency),
        sipStartDate: convertDate(startDate),
        sipEndDate: convertDate(endDate),
        noOfInstallments: Number(noOfInstallments),
        schemeName: label,
        modeOfRegistration: values.modeOfRegistration,
        category,
        sipDay: sipDay,
        perpetual: values.perpetual,
        mobile: values.mobile.toString(),
        familyMobileFlag: values.mobileFamily,
        email: values.email,
        installmentAmount: Number(installmentAmount),
        familyEmailFlag: values.emailFamily,
        transactionType: values.sipType === NEWP ? "SIN" : "SINI",
        newPurchaseSipType: values.sipType === NEWP ? "SIPN" : "",
        combo: values.sipType === NEWP ? values.combo : false,
        invCategory: values.invCategory,
        sipAutoRenewal:values.sipAutoRenewal,
        sipAutoRenewalEnddate:sipAutoRenewalEnddateCalculator(values),
      };
      const response = await addItemsToCart(requestBody)(dispatch);
      if (response) {
        const [newCartItem] = response.cartItems.sort(
          (item1: any, item2: any) =>
            Number(item2.cartItemId) - Number(item1.cartItemId)
        );
        setModalDetails({
          isOpen: true,
          bulkOrderId: response.bulkOrderId,
          ihNo: newCartItem.ihno,
        });
      }
    } catch (error) {
      handleError(error);
    }
  }

  const handlePerpetual: HandleCheckBoxChange = function (values, setValues) {
    return function (e, checked) {
      const isChecked = checked;
      const { frequency } = values;
      if (!isChecked) {
        const updatedFields = resetLaterFields(values, "frequency", {
          perpetual: false,
          sipAutoRenewal:false,
        });
        setValues(updatedFields);
        return;
      }

      if (values.modeOfRegistration === "ISIP") {
        const noOfInstallments = calculateNoOfInstallments(
          frequency,
          values.startDate,
          "ISIP"
        );
        const endDate = getPerpetualSipEndDate(values.startDate, "ISIP");
        const updatedFields = resetLaterFields(values, "endDate", {
          perpetual: true,
          noOfInstallments,
          endDate: moment(endDate).format("DD/MM/YYYY"),
        });
        setValues(updatedFields);
        return;
      }

      const noOfInstallments = calculateNoOfInstallments(
        frequency,
        values.startDate
      );
      const endDate = getPerpetualSipEndDate(values.startDate);
      const updatedFields = resetLaterFields(values, "endDate", {
        perpetual: true,
        sipAutoRenewal:false,
        noOfInstallments,
        endDate: moment(endDate).format("DD/MM/YYYY"),
      });
      setValues(updatedFields);
    };
  };
  const getPerpetualSipEndDate = (startDate: string, mode?: "ISIP") => {
    const [startDay] = moment(startDate, "DD/MM/YYYY")
      .format("DD/MM/YYYY")
      .split("/");

    if (mode === "ISIP") {
      const endDate = new Date(2099, 11, Number(startDay));
      return endDate;
    }

    const date = new Date();
    date.setDate(Math.min(Number(startDay), 28));
    date.setMonth(date.getMonth() - 1);
    date.setFullYear(date.getFullYear() + 40);
    return date;
  };

  const calculateNoOfInstallments = (
    frequency: any,
    startDate: string,
    mode?: "ISIP"
  ): string => {
    const ONE_MINUTE = 1000 * 60;
    const ONE_HOUR = ONE_MINUTE * 60;
    const ONE_DAY = ONE_HOUR * 24;

    const newStartDate = new Date(convertDate(startDate));

    const endDate = getPerpetualSipEndDate(startDate, mode);

    const noOfMonths = differenceInMonths(endDate, newStartDate);
    const frequencyMap: any = {
      DAILY: Math.floor((endDate.getTime() - newStartDate.getTime()) / ONE_DAY),
      WEEKLY: Math.floor(
        (endDate.getTime() - newStartDate.getTime()) / ONE_DAY / 7
      ),
      FORTNIGHTLY: Math.floor(noOfMonths * 2),
      MONTHLY: Math.floor(noOfMonths),
      QUARTERLY: Math.floor(noOfMonths / 3),
      HALFYEARLY: Math.floor(noOfMonths / 6),
      YEARLY: Math.floor(noOfMonths / 12),
    };

    if (frequencyMap[frequency.toUpperCase()]) {
      return frequencyMap[frequency.toUpperCase()];
    }

    return "";
  };

  const onSubmit = async (values: Values, helpers: FormikHelpers<Values>) => {
    try {
      const errors = await helpers.validateForm(values);
      if (Object.keys(errors).length) {
        helpers.setErrors(errors);
        return;
      }
      const {
        fund,
        endDate,
        category,
        frequency,
        installmentAmount,
        amount,
        noOfInstallments,
        scheme,
        sipDay,
        startDate,
      } = values;

      const schemeDetails = schemes.find(({ value }) => value === scheme)!;

      const { option, plan, scheme: selectedScheme, label } = schemeDetails;

      const requestBody = {
        investorName: investorData.invname,
        pan: investorData.PAN,
        fund,
        scheme: selectedScheme,
        plan,
        option,
        arnCode,
        perpetual: values.perpetual,
        subArn: values.subArn,
        dcr: "KTRWD",
        euinDeclaration: values.euinDeclaration === "Yes" ? "N" : "Y",
        userId,
        euin: values.euinDeclaration === "Yes" ? values.euin : "",
        subBroker: values.subBrokerCode,
        amount: values.sipType === NEWP ? amount : 0,
        remarks: "0",
        sipFrequency: getFrequencyName(frequency),
        sipStartDate: convertDate(startDate),
        sipEndDate: convertDate(endDate),
        noOfInstallments: Number(noOfInstallments),
        schemeName: label,
        category,
        sipDay: sipDay,
        mobile: values.mobile.toString(),
        familyMobileFlag: values.mobileFamily,
        email: values.email,
        installmentAmount: Number(installmentAmount),
        familyEmailFlag: values.emailFamily,
        transactionType: values.sipType === NEWP ? "SIN" : "SINI",
        fundName: amcMasters.find((v) => v.value === values.fund).label,
        sipAutoRenewal:values.sipAutoRenewal,
        sipAutoRenewalEnddate:sipAutoRenewalEnddateCalculator(values),
      };
      history.replace("new-investor-transaction/investor-details", {
        requestBody,
        isSingle: true,
        isCart: false,
        pan: investorData.PAN,
        transactionType: values.sipType === NEWP ? "SIN" : "SINI",
        newPurchaseSipType: values.sipType === NEWP ? "SIN" : "",
      });
    } catch (error) {
      handleError(error);
    }
  };

  const resetLaterFields = function (
    values: Values,
    key: keyof Values,
    fieldValues: Partial<Values>
  ): Values {
    const index = FIELD_NAMES.findIndex((fieldName) => fieldName === key);
    const updatedValues = FIELD_NAMES.slice(index).reduce<Partial<Values>>(
      (acc, curr) => {
        return {
          ...acc,
          [curr]: "",
          email: values.email,
          mobile: values.mobile,
          emailFamily: values.emailFamily,
          mobileFamily: values.mobileFamily,
        };
      },
      {}
    );

    return { ...values, ...updatedValues, ...fieldValues };
  };

  const fetchModeOfRegistrationOptions = async function (fund: string) {
    const payload = {
      opt: PAYMENT_MODE,
      astscheme: investorData.PAN,
      Fund: fund,
    };
    const response = await swpOptions(payload)(dispatch);
    if (!response) return;
    if (!response?.Dtinformation?.length) return;

    const isPanBasedAotm = await checkAotmStatus(fund)(dispatch);

    const paymodes = response.Dtinformation.map(
      ({ Pay_Mode, Pay_Mode_Val }: any) => ({
        label: Pay_Mode,
        value: Pay_Mode_Val,
      })
    )
      .filter((i: Option) => {
        if (fund !== "129") return true;
        return i.value !== "AOTM";
      })
      .filter((option: any) =>
        isPanBasedAotm ? true : option.value !== "AOTM"
      );

    setModeOptions(paymodes);
  };

  const handleModeOfRegistrationChange: HandleChange = function (
    values,
    setValues
  ) {
    return function (e) {
      const updatedValues = resetLaterFields(values, "modeOfRegistration", {
        modeOfRegistration: e.target.value,
      });
      setValues(updatedValues);
    };
  };

  const handleAmcChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const fund = e.target.value;
        const response = await getSipCategory(fund)(dispatch);
        setCategories(response);
        setValues(
          resetLaterFields(values, "fund", {
            fund,
          })
        );
        setEuinOptions(
          await validateSubBroker({
            arnCode: arnCode,
            fundCode: fund,
            subArnCode: "",
          })(dispatch)
        );
        await fetchModeOfRegistrationOptions(fund);
        if (response.length === 1) {
          setValues(
            resetLaterFields(values, "fund", {
              euin: response[0].value,
              fund,
            })
          );
        }
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleTypeChange: HandleChange = function (values, setValues) {
    return function (e) {
      setValues(
        resetLaterFields(values, "sipType", {
          sipType: e.target.value,
        })
      );
    };
  };

  const handleCategoryChange: HandleChange = function (values, setValues) {
    return async function (e) {
      const category = e.target.value;
      const response = await getSipSchemes({
        category,
        acno: "0",
        fundCode: values.fund,
      })(dispatch);
      setSchemes(response);
      setValues(
        resetLaterFields(values, "category", {
          category,
        })
      );
    };
  };

  const handleSchemeChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const scheme = e.target.value;
        const selectedScheme = schemes.find(({ value }) => scheme === value);
        const { newPurchaseMinAmount = 100, multiples = 1 } = selectedScheme;
        const response = await getSipFrequency(
          values.fund,
          selectedScheme.scheme,
          selectedScheme.plan
        )(dispatch);
        setFrequencies(response);
        setValues(
          resetLaterFields(values, "scheme", {
            scheme,
            newPurchaseMinAmount,
            multiples,
          })
        );
        return;
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleFrequencyChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const frequency = e.target.value;
        const response = await getSipDayList(values.fund, frequency)(dispatch);
        const selectedFrequency = frequencies.find(
          ({ value }) => value === frequency
        );
        const { minimumInstallments } = selectedFrequency;
        const selectedScheme = schemes.find(
          ({ value }) => value === values.scheme
        );
        setSipDays(response);
        const requestBody = {
          Fund: values.fund,
          TrType: "SIP",
          Frequency: frequency,
          Scheme: selectedScheme.scheme,
        };
        const minResponse = await getMinimumAmount(requestBody)(dispatch);

        const sipMinAmount = minResponse.DtData[0].minamt;

        const { minAmount } = getSchemeDetails(selectedScheme);

        const isAllowed = await isSchemeFreedomEligible({
          fund: values.fund,
          scheme: selectedScheme.scheme,
          frequency,
          option: selectedScheme.option,
        })(dispatch);

        if (isAllowed) {
          const freedomSchemesResponse = await getFreedomSipCategories({
            fund: values.fund,
          })(dispatch);

          setFreedomCategories(freedomSchemesResponse);

          const tenuresResponse = await getSipTenures({
            fund: values.fund,
            frequency,
            scheme: selectedScheme.scheme,
          })(dispatch);

          setSipTenures(tenuresResponse);
        }

        setValues(
          resetLaterFields(values, "frequency", {
            frequency,
            minimumInstallments,
            sipMinAmount,
            newPurchaseMinAmount: isAllowed ? minAmount : sipMinAmount,
            isFreedomEligible: isAllowed,
          })
        );
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleFreedomCategoryChange: HandleChange = function (
    values,
    setValues
  ) {
    return async function (e) {
      const category = e.target.value;
      const freedomSchemeResponse = await getFreedomSipSchemes({
        fund: values.fund,
        category,
      })(dispatch);
      setFreedomSchemes(freedomSchemeResponse);
      setValues(
        resetLaterFields(values, "freedomCategory", {
          freedomCategory: category,
          noOfInstallments: values.noOfInstallments,
        })
      );
    };
  };

  const handleFreedomSchemeChange: HandleChange = function (values, setValues) {
    return async function (e) {
      const scheme = e.target.value;
      const selectedScheme = freedomSchemes.find((s) => s.value === scheme);
      const { sipMinAmount, value } = selectedScheme;
      const requestBody = {
        Fund: values.fund,
        TrType: "SWP",
        Frequency: values.frequency,
        Scheme: getSchemeDetails(selectedScheme).scheme,
      };

      const minResponse = await getMinimumAmount(requestBody)(dispatch);
      const swpMinAmount = minResponse.DtData[0].minamt;

      const updatedFields = resetLaterFields(values, "freedomScheme", {
        freedomScheme: scheme,
        sipMinAmount: String(sipMinAmount),
        noOfInstallments: values.noOfInstallments,
        swpMinAmount: swpMinAmount,
      });

      setValues(updatedFields);
    };
  };

  const handleTenureChange: HandleChange = function (values, setValues) {
    return function (e) {
      const tenure = e.target.value;
      const updatedFields = resetLaterFields(values, "sipTenure", {
        sipTenure: tenure,
        noOfInstallments: String(tenure * 12),
      });
      setValues(updatedFields);
      setFreedomSchemes([]);
    };
  };

  const handleSipDayChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const sipDay = e.target.value;
        const selectedScheme = schemes.find(
          (s) => s.value === values.scheme
        ).scheme;
        const requestBody = {
          fund: values.fund,
          sch: selectedScheme,
          StartDate: sipDay,
          Installments: Number(values.noOfInstallments),
          Frequency: values.frequency,
          trtype: "SIP",
          modeofregistration: values.modeOfRegistration,
        };
        const response = await CalcSIPEnddt(requestBody)(dispatch);
        const {
          DtData: [dates],
        } = response;
        const { SIP_StartDate, SIP_EndDate, SWP_StartDate, SWP_EndDate } =
          dates;
        const isIsip = values.modeOfRegistration === "ISIP";
        const formattedEndDate = new Date(convertDate(SIP_EndDate));
        const perpetualEndDate = isIsip
          ? getPerpetualSipEndDate(SIP_StartDate, "ISIP")
          : getPerpetualSipEndDate(SIP_StartDate);
        const isValidEndDate =
          formattedEndDate.getTime() <= perpetualEndDate.getTime();

        if (!isValidEndDate) {
          setValues(
            resetLaterFields(values, "noOfInstallments", {
              sipDay: "",
              startDate: "",
              endDate: "",
            })
          );
          throw new Error(
            `SIP End date cannot exceed ${convertDateToIndian(
              perpetualEndDate
            )}`
          );
        }

        setValues(
          resetLaterFields(values, "startDate", {
            sipDay: sipDay,
            startDate: SIP_StartDate,
            endDate: SIP_EndDate,
            swpStartDate: SWP_StartDate,
            swpEndDate: SWP_EndDate,
          })
        );
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleSubArnChange = function (
    values: Values,
    setValues: React.Dispatch<React.SetStateAction<Values>>
  ): TextFieldProps["onBlur"] {
    return async function (e) {
      try {
        const subArn = e.target.value;
        const response = await validateSubBroker({
          arnCode: values.arnCode,
          subArnCode: `ARN-${subArn}`,
          fundCode: values.fund,
        })(dispatch);
        setEuinOptions(response);
        setValues(resetLaterFields(values, "subArn", { subArn }));
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleInstallmentChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const noOfInstallments = e.target.value;
        setValues(
          resetLaterFields(values, "noOfInstallments", {
            noOfInstallments,
          })
        );
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleIsSameSchemeChange: HandleCheckBoxChange = function (
    values,
    setValues
  ) {
    return async function (e, checked) {
      const isChecked = checked;
      if (!isChecked) {
        resetLaterFields(values, "freedomCategory", {
          isSameScheme: false,
        });
        return;
      }

      const sipScheme = schemes.find(({ value }) => values.scheme === value);
      const { scheme, plan, option } = getSchemeDetails(sipScheme);

      const swpScheme = freedomSchemes.find(
        (x) => x.scheme === scheme && x.plan === plan && x.option === option
      );
      const { sipMinAmount } = swpScheme;

      const requestBody = {
        Fund: values.fund,
        TrType: "SWP",
        Frequency: values.frequency,
        Scheme: scheme,
      };

      const minResponse = await getMinimumAmount(requestBody)(dispatch);
      const swpMinAmount = minResponse.DtData[0].minamt;

      const updatedFields = resetLaterFields(values, "freedomScheme", {
        freedomScheme: values.scheme,
        sipMinAmount: String(sipMinAmount),
        noOfInstallments: values.noOfInstallments,
        swpMinAmount: swpMinAmount,
        isSameScheme: true,
      });
      setValues(updatedFields);
    };
  };

  const handleSipAmountChange: HandleChange = function (values, setValues) {
    return function (e) {
      const amount = e.target.value;

      if (values.isFreedom !== "freedomSip") {
        const updatedFields = resetLaterFields(values, "installmentAmount", {
          installmentAmount: amount,
        });
        setValues(updatedFields);
        return;
      }

      const selectedTenure = sipTenures.find(
        (t) => t.value === values.sipTenure
      );
      const { multiplier } = selectedTenure;
      const updatedFields = resetLaterFields(values, "installmentAmount", {
        installmentAmount: amount,
        swpAmount: String(Number(amount) * multiplier),
      });
      setValues(updatedFields);
    };
  };
  useEffect(() => {
    (async function () {
      try {
        const kycResponse = await getKycDetails({ pan: investorData.PAN })(
          dispatch
        );
        const { DtData = [] } = kycResponse;
        const [kycDetails = {}] = DtData;
        setAmcMasters(await getAmcMasters()(dispatch));
        const { email, mobile } = kycDetails;
        setInitialValues((prev) => ({
          ...prev,
          email,
          mobile,
        }));
        await getInvestorDetailsByPan(investorData.PAN)(dispatch);
      } catch (error) {
        handleError(error);
      }
    })();
  }, [dispatch, investorData.PAN]);

  return {
    options: {
      schemes,
      sipDays,
      amcMasters,
      categories,
      euinOptions,
      frequencies,
      sipType: SIP_TYPE_OPTIONS_NEW,
      familyDescription: FAMILY_OPTIONS,
      modeOptions,
      sipTenures,
      freedomSchemes,
      freedomCategories,
    },
    submit,
    addToCart,
    onSubmit,
    changeHandlers: {
      handleAmcChange,
      handleTypeChange,
      handleSubArnChange,
      handleCategoryChange,
      handleSchemeChange,
      handleFrequencyChange,
      handleSipDayChange,
      handleInstallmentChange,
      handlePerpetual,
      handleModeOfRegistrationChange,
      handleFreedomCategoryChange,
      handleFreedomSchemeChange,
      handleTenureChange,
      handleSipAmountChange,
      handleIsSameSchemeChange,
    },
    initialValues,
    pan: investorData.PAN,
    investorName: investorData.invname,
    history,
    modalDetails,
  };
}

export const validationSchema = Yup.object().shape({
  invCategory: Yup.string().required("Investor Category is required*"),
  fund: Yup.string().required("AMC is required*"),
  sipType: Yup.string().required("SIP Type is required*"),
  category: Yup.string().required("Category is required"),
  email: Yup.string().required("Email is required*").email("Invalid Email"),
  emailFamily: Yup.string().required("Family description is required"),
  modeOfRegistration: Yup.string().required(
    "Mode of Registration is required*"
  ),
  mobile: Yup.string()
    .required("Mobile is required*")
    .when("invCategory", {
      is: (value: string) => value === "11",
      then: (schema) =>
        schema.matches(mobileRegex, "Enter a valid 10 digit mobile number"),
      otherwise: (schema) =>
        schema.matches(/^[0-9]{5,18}$/, "Enter a valid mobile number"),
    })
    .matches(mobileRegex, "Enter a valid 10 digit mobile number"),
  mobileFamily: Yup.string().required("Family description is required"),
  scheme: Yup.string().required("Scheme is required*"),
  frequency: Yup.string().required("Frequency is required*"),
  noOfInstallments: Yup.string()
    .required("No of Installments is required*")
    .test("minimum installments", function (value) {
      const { parent } = this;
      const { minimumInstallments } = parent;
      if (Number(value) < Number(minimumInstallments)) {
        return this.createError({
          message: `Minimum number of installments is ${minimumInstallments}`,
        });
      }
      return true;
    }),
  sipDay: Yup.string().required("Sip Day is required*"),
  startDate: Yup.string().required("Sip Start Date is required*"),
  endDate: Yup.string().required("Sip Start Date is required*"),
  installmentAmount: Yup.string()
    .required("Installment amount is required*")
    .test("minimum SIP amount", function (amount) {
      const { sipMinAmount = 500, multiples = 1 } = this.parent;
      if (Number(sipMinAmount) > Number(amount)) {
        return this.createError({
          message: `Minimum amount is  ${convertToInr(sipMinAmount)}`,
        });
      }
      if (Number(amount) % Number(multiples) !== 0) {
        return this.createError({
          message: `SIP Amount should be a multiple of ${multiples}`,
        });
      }
      return true;
    }),
  amount: Yup.string().when("sipType", {
    is: (value: string) => [NEWP, EXISTINGP].includes(value),
    then: Yup.string()
      .required("Lumpsum amount is required for purchase with payment*")
      .test("minimum lumpsum amount", function (amount) {
        const { newPurchaseMinAmount = 500, multiples = 1 } = this.parent;
        if (Number(newPurchaseMinAmount) > Number(amount)) {
          return this.createError({
            message: `Minimum amount is  \u20B9 ${newPurchaseMinAmount}`,
          });
        }
        if (Number(amount) % Number(multiples) !== 0) {
          return this.createError({
            message: `Amount should be a multiple of ${multiples}`,
          });
        }

        return true;
      }),
    otherwise: Yup.string().notRequired(),
  }),
  euinDeclaration: Yup.string().required("Euin Declaration is required"),
  euin: Yup.string().when("euinDeclaration", {
    is: (value: string | undefined) => (value || "").toUpperCase() === "YES",
    then: (schema) => schema.required("EUIN Number is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  subArn: Yup.string()
    .notRequired()
    .test("arnCode", "Invalid ARN Code", function (value) {
      const { arnCode } = this.parent;
      if (arnCode === value || `ARN-${value}` === arnCode) {
        return this.createError({
          message: `ARN Code and Sub ARN Code cannot be same`,
        });
      }

      return true;
    }),
  subBrokerCode: Yup.string()
    // .matches(new RegExp(/^[a-zA-Z0-9]$/), "Enter a valid sub broker code")
    .notRequired(),
  isFreedomEligible: Yup.boolean(),
  isFreedom: Yup.string(),
  freedomCategory: Yup.string(),
  freedomScheme: Yup.string(),
  swpStartDate: Yup.string().when("isFreedom", {
    is: (value: string) => value === "freedomSip",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  swpEndDate: Yup.string().when("isFreedom", {
    is: (value: string) => value === "freedomSip",
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  swpAmount: Yup.string().when("isFreedom", {
    is: (value: string) => value === "freedomSip",
    then: (schema) =>
      schema
        .required("Withdrawal Amount is required")
        .test("minimum SWP amount", function (amount) {
          const { swpMinAmount = 500 } = this.parent;

          if (Number(swpMinAmount) > Number(amount)) {
            return this.createError({
              message: `Minimum amount is  ${convertToInr(swpMinAmount)}`,
            });
          }
          return true;
        }),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
});

export interface Values {
  fund: string;
  sipType: string;
  scheme: string;
  category?: string;
  email: string;
  mobile: string;
  emailFamily: string;
  mobileFamily: string;
  frequency: string;
  noOfInstallments: string;
  sipDay: string;
  startDate: string;
  endDate: string;
  installmentAmount: string;
  arnCode: string;
  subArn?: string;
  subBrokerCode?: string;
  euinDeclaration: "Yes" | "No" | "";
  euin?: string;
  amount?: string;
  minimumInstallments?: string | number;
  sipMinAmount?: string | string;
  newPurchaseMinAmount?: string | number;
  multiples?: string | number;
  perpetual?: boolean;
  sipAutoRenewal?: boolean;
  combo?: boolean;
  invCategory: "11" | "20";
  modeOfRegistration: "" | "ISIP" | "KOTM" | "AOTM";
  isFreedomEligible: boolean;
  isFreedom: string;
  freedomCategory: string;
  swpMinAmount?: string;
  freedomScheme: string;
  sipTenure: string;
  swpStartDate: string;
  swpEndDate: string;
  isSameScheme?: boolean;
  swpAmount: string;
}
